import { createAsyncThunk } from "@reduxjs/toolkit";
import { upload_triplicates_patient_sign } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";

export const UploadedTriplicatesPatientSign = createAsyncThunk('UploadedTriplicatesPatientSign', async (requestedData, { rejectWithValue }) => {
    try {

        const response = await Axios.post(upload_triplicates_patient_sign,
            {
                pharmacy_id: requestedData.pharmacy_id,
                rxnum: requestedData.rxnumber,
                win_rx_data_id: requestedData.win_rx_data_id,
                patient_sign: requestedData.patient_sign
            })

        const data = response.data

        if (typeof requestedData.setShowToast === 'function') {
            requestedData.setShowToast((prevstat) => ({ ...prevstat, successToast: true }))
            setTimeout(() => {
                requestedData.setShowToast((prevstat) => ({ ...prevstat, successToast: false }))
                    requestedData.setIsModalOpen(false)
            }, 1000);
        }

        return data;

    } catch (error) {

        if (typeof requestedData.setShowToast === 'function') {
            requestedData.setShowToast((prevstat) => ({ ...prevstat, errorToast: true }))
            setTimeout(() => {
                requestedData.setShowToast((prevstat) => ({ ...prevstat, errorToast: false }))
            }, 5000);
        }

        return rejectWithValue(error.response)
    }
});